import React, {useState} from 'react'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import {MenuItem} from '@mui/material'

function Profile({onSuccessfulLogout, loggedInUser}) {
    const onSuccess = () => {
        onSuccessfulLogout();
    }

    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const closeMenu = () => {
        setAnchorEl(null);
    };

    return (
        <div className="profile">
            <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleMenu}>{loggedInUser.Username}</Button>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
                <MenuItem onClick={closeMenu}>
                    <span onClick={onSuccess}>Logout</span>
                </MenuItem>
            </Menu>
        </div>
    );
}

export default Profile;
